<template>
  <v-container>
    <v-container>
      <v-row>
        <v-col cols="12" class="test-title text-h5">
          <strong>{{ teste.nome }}</strong>
        </v-col>
      </v-row>
      <v-divider />
    </v-container>

    <v-container>
      <v-row>
        <v-item-group
          v-model="window"
          class="shrink ma-3 steps"
          mandatory >
          <v-container class="steps__container">
            <v-item
              v-for="n in teste.qtdQuestoes"
              :key="n"
              v-slot="{ active, toggle }" >
              <div class="pa-1">
                <v-btn
                  class="my-1"
                  fab
                  small
                  :input-value="active"
                  @click="doToggle(toggle)"
                  color="deep-purple lighten-1 white--text" active-class="indigo darken-3 elevation-3"
                >
                  {{ n }}
                </v-btn>
              </div>
            </v-item>
          </v-container>
        </v-item-group>

        <v-col class="question-box">
          <v-window v-model="window" class="elevation-1">
            <v-window-item
              v-for="questao in teste.questoesList"
              :key="questao.pergunta"
            >
              <v-card flat>
                <v-card-text>
                  <v-row class="ml-0">
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            color="grey"
                            large
                            v-bind="attrs"
                            v-on="on"
                            @click="dialogReportar = !dialogReportar"
                          >
                            <v-icon>mdi-information</v-icon>
                          </v-btn>
                        </template>
                        <span>Reportar erro</span>
                      </v-tooltip>
                      <v-tooltip top v-if="false">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            color="grey"
                            large
                            v-bind="attrs"
                            v-on="on"
                            @click="overlay = !overlay"
                          >
                            <v-icon>mdi-lightbulb-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Modo noturno</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            color="grey"
                            large
                            v-bind="attrs"
                            v-on="on"
                            @click="tamanhoFonte = tamanhoFonte + 3"
                          >
                            <v-icon>mdi-magnify-plus-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Aumentar tamanho da fonte</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            color="grey"
                            large
                            v-bind="attrs"
                            v-on="on"
                            @click="tamanhoFonte = 16"
                          >
                            <v-icon>mdi-magnify</v-icon>
                          </v-btn>
                        </template>
                        <span>Redefinir tamanho da fonte</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            color="grey"
                            large
                            v-bind="attrs"
                            v-on="on"
                            @click="tamanhoFonte = tamanhoFonte - 3"
                          >
                            <v-icon>mdi-magnify-minus-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Diminuir tamanho da fonte</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            large
                            v-bind="attrs"
                            v-on="on"
                            @click="questao.favorito = !questao.favorito"
                          >
                            <v-icon v-if="questao.favorito" color="red"
                              >mdi-heart</v-icon
                            >
                            <v-icon v-if="!questao.favorito" color="grey"
                              >mdi-heart-outline</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Favoritar questão</span>
                      </v-tooltip>
                    </v-col>

                    <v-dialog v-model="dialogReportar" max-width="500px">
                      <v-card>
                        <v-card-title>
                          Reportar erro desta pergunta
                        </v-card-title>
                        <v-card-text>
                          <p>
                            Encontrou um erro? Escreva de forma detalhada para
                            nós que avaliaremos o mais breve possivel.
                          </p>
                          <v-textarea v-model="erro"></v-textarea>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            dark
                            @click="enviarErro(questao.idQuestao)"
                          >
                            Enviar
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                  <v-row class="ml-0">
                    <v-col v-bind:style="{ fontSize: tamanhoFonte + 'px' }">
                      <p class="questao" v-html="questao.pergunta"></p>
                      <v-spacer></v-spacer>
                    </v-col>
                  </v-row>

                  <v-list two-line>
                    <v-list-item-group 
                      v-model="questao.selecionada"
                      active-class="text--darken-5"
                    > 
                      <template v-for="(item, index) in questao.respostas">
                        <v-list-item
                          :key="index"
                          :class="getClass(questao, item)" :disabled="testeFinalizado"
                        >
                          <template >
                            <v-list-item-action>
                              <v-icon
                                v-if="!(index == questao.selecionada)" 
                                :color="getColor(questao, item)"
                              >
                                mdi-circle-outline
                              </v-icon> 
                              <v-icon v-else :color="getColor(questao, item)">
                                mdi-circle-slice-8
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title
                                v-bind:style="{ fontSize: tamanhoFonte + 'px' }"
                                >{{ item.resposta }}
                              </v-list-item-title>
                              <v-list-item-subtitle
                                v-bind:style="{ fontSize: tamanhoFonte + 'px' }"
                                v-if="abrirItem"
                                class="text--primary"
                                v-text="item.comentario"
                              ></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                    <v-col align="end" v-if="teste.modoTeste == 1">
                      <v-btn
                        :disabled="!isAnswered(questao) || testeFinalizado"
                        depressed
                        small
                        color="primary"
                        @click="validarRespostas(questao)"
                        v-bind:style="{ fontSize: tamanhoFonte + 'px' }"
                      >
                        Validar Resposta
                      </v-btn>
                    </v-col>
                    
                  </v-list>
                  <v-container
                    v-if="abrirItem"
                    v-bind:style="{ fontSize: tamanhoFonte + 'px' }"
                  >
                    <v-row class="ml-4 mb-4">
                      <strong class="subtitle">Explicação</strong>
                      <v-spacer></v-spacer>
                    </v-row>
                    <v-row class="ml-4">
                      <p v-html="questao.comentario"></p>
                    </v-row>
                  </v-container>
                  <v-snackbar
                    right
                    top
                    color="success"
                    v-model="snackbar"
                    :timeout="6000"
                  >
                    Sua mensagem foi enviada com sucesso.
                    <template v-slot:action="{ attrs }">
                      <v-btn
                        color="blue"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                      >
                        <v-icon dark> mdi-colse </v-icon>
                      </v-btn>
                    </template>
                  </v-snackbar>
                </v-card-text>
              </v-card>
            </v-window-item>
          </v-window>
          <v-btn text @click="prev">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn text @click="next">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-col align="end">
                      <v-btn
                        class="mr-4"
                        depressed
                        small
                        :disabled="testeFinalizado"
                        color="primary"
                        @click="pausarTeste()"
                        v-bind:style="{ fontSize: tamanhoFonte + 'px' }"
                      > Pausar </v-btn>
                      
                      <v-btn
                        :disabled="testeFinalizado"
                        depressed
                        small
                        color="green"
                        @click="finalizarTeste()"
                        v-bind:style="{ fontSize: tamanhoFonte + 'px' }"
                      > Finalizar prova </v-btn>
                    </v-col>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar
      right
      top
      :color="snackbarType"
      v-model="snackbarFeedbackTest"
      :timeout="6000">
      <span v-html="message"></span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbarFeedbackTest = false"
        >
          <v-icon dark> mdi-colse </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
  
</template>
<script>
import { mapActions } from "vuex";
import Teste from "../../models/teste";

export default {
  data: () => ({
    teste: '',
    erro: '',
    snackbar: false,
    snackbarFeedbackTest: false,
    snackbarType:'success',
    message: '',
    window: 0,
    onboarding: 0,
    abrirItem: false,
    testeFinalizado:false,
    bkgColor: '',
    tamanhoFonte: 16,
    overlay: true,
    respostasValidadas: [],
    dialogReportar: false,
  }),

  created() {
    this.initialize();
  },

  watch: {
    window(val) {
      if (this.teste.modoTeste === 1 && this.testeFinalizado === false) {
        this.abrirItem = this.respostasValidadas.includes(val);
      }
    },
  },

  methods: {
    ...mapActions("test", ["getTest", "updateTest"]),
    async initialize() { 
      const resp = await this.getTest(this.$route.params.teste);
      this.exibirCronometro = false;
      this.teste = new Teste(resp);
      if(this.teste.status !== 'Iniciado'){
        if(!this.$route.query.refazer){
          this.teste.questoesList.forEach(questao => {
            if(questao.respostaUsuario){
              for(var r in questao.respostas){
                if(questao.respostas[r].idResposta === questao.respostaUsuario)
                  questao.selecionada = r;
              }
            }
          });
          if(this.teste.status === 'Concluído'){
            this.testeFinalizado = true;
            this.abrirItem = true; 
          }
        }else{
          this.teste.status = 1
          this.teste.questoesList.forEach(questao => {
            questao.respostaUsuario = ''
          });
        }
      }
    },
    getColor(questao, item) {
      if (this.abrirItem) {
        if (!item.correta) {
          return "green";
        } else {
          return "red";
        }
      } else {
        return "indigo dark-1";
      }
    },
    getClass(questao, item) {
      if (this.abrirItem) {
        if (!item.correta) {
          questao;
          return "green lighten-5";
        } else {
          return "red lighten-5";
        }
      } else {
        return "";
      }
    },
    next() {
      this.window =
        this.window + 1 === this.teste.qtdQuestoes ? 0 : this.window + 1;
    },
    prev() {
      this.window =
        this.window - 1 < 0 ? this.teste.qtdQuestoes - 1 : this.window - 1;
    },
    doToggle(toggleFn){
      toggleFn()
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    onStepClick(toggle) {
      toggle();
    },
    isAnswered(questao) {
      return (
        questao.selecionada !== "" &&
        questao.selecionada !== undefined &&
        questao.selecionada !== null
      );
    },
    ...mapActions("error", ["createError"]),
    validarRespostas(questao) {
      this.questoesCertas(questao);
      this.abrirItem = true;
      !this.respostasValidadas.includes(this.window) &&
        this.respostasValidadas.push(this.window);
    },
    async enviarErro(idQuestao) {
      const req = {
        comentario: this.erro,
        idQuestao: idQuestao,
      };
      const resp = await this.createError(req);
      if (resp.status == 200) {
        this.snackbar = true;
        this.dialogReportar = false;
        this.erro = "";
      } else {
        this.dialogReportar = false;
        this.erro = "";
      }
    },
    async finalizarTeste() {
      var testePayload = JSON.parse(JSON.stringify(this.teste));
      this.abrirItem = true;
      for (var q in testePayload.questoesList) {
        this.questoesCertas(testePayload.questoesList[q]);
        testePayload.questoesList[q].comentario = null
        testePayload.questoesList[q].pergunta = null
        testePayload.questoesList[q].respostas = null
      }
      testePayload.status = 3;
      const resp = await this.updateTest(testePayload);
      if (resp.status == 200) {
        this.message = 'Teste finalizado com Sucesso.<br/> Você será redirecionado para a Dashboard em alguns segundos';
        this.snackbarFeedbackTest = true;
        this.testeFinalizado = true;
      } else {
        this.message = 'Ocorreu um problema ao finalizar seu teste. <br/> entre em contato com o suporte.';
        this.snackbarType = 'warning'
        this.snackbarFeedbackTest = true;
        this.testeFinalizado = true;
      }
    },
    
    async pausarTeste() {
      var testePayload = JSON.parse(JSON.stringify(this.teste));
      
      for (var q in testePayload.questoesList) {
        this.questoesCertas(testePayload.questoesList[q]);
        testePayload.questoesList[q].comentario = null
        testePayload.questoesList[q].pergunta = null
        testePayload.questoesList[q].respostas = null
      }
      testePayload.status = 2; //muda status para pausado
      const resp = await this.updateTest(testePayload);
      if (resp.status == 200) {
        confirm("Teste pausado") && this.$router.push({ name: "meusTestes" });
        this.testeFinalizado = true;
      } else {
        alert("Erro");
      }
    },
    questoesCertas(questao) {
      var idRespostaCorreta='';
      for (var n of questao.respostas){
        if (n.correta != 1) idRespostaCorreta = n.idResposta
      }
      if (
        questao.selecionada != null &&
        questao.selecionada !== "" &&
        questao.selecionada != undefined
      )
      questao.respostaUsuario = questao.respostas[questao.selecionada].idResposta;
      if(questao.respostaUsuario != null &&
        questao.respostaUsuario !== "" &&
        questao.respostaUsuario != undefined){
        questao.acerto = idRespostaCorreta === questao.respostaUsuario;
      }else{
        questao.respostaUsuario = null; /** Set null para o Back entender que null e nao e false */
      }

    },
  },
};
</script>

<style lang="scss" scoped>
.red.v-list-item--link:before {
  background-color: red;
}

.green.v-list-item--link:before {
  background-color: #4caf50;
}

.v-list-item__title,
.v-list-item__subtitle {
  overflow: hidden;
  text-overflow: clip;
  white-space: initial;
}

p ::v-deep img {
  width: 100%;
}

p ::v-deep iframe {
  width: 100%;
}

@media screen and (min-width: 540px) {
  .question-box {
    max-width: 94%;
  }
}
@media screen and (max-width: 540px) {
  .test-title {
    margin-top: 50px;
  }
  .steps {
    display: flex;
    justify-content: flex-start;
    overflow-x: auto;
    position: fixed;
    z-index: 1;
    width: 100%;
    background: #fff;
    top: 29px;
    padding-top: 10px;
    left: -14px;
    &__container {
      display: flex;
    }
  }
  .teste {
    max-width: 100%;
    width: 300px;
    height: auto;
  }
  .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
      opacity: revert!important;
      color: #341e5d!important;
  }
}
</style>
